import Vue from 'vue';
import router from '@returns-centre/routes';
import { store } from "@returns-centre/store";
import App from './App.vue';
import VueModal from '@/components/VueModal.vue';
import {i18n} from '@/i18n';
import  {
    AppPage,
    AppActionButton,
    AppBanner,
    AppCircle,
    AppCheckboxInput,
    AppRadioInput,
    AppCheckmark,
    AppTextInput,
    AppSelectInput,
    AppLoadingOverlay,
    AppCreditAmountContainer,
    AppImagePlaceholder,
    AppAccordion,
    AppBadge,
    AppButton,
    AppLookupButton
} from '@returns-centre/components';

import Spinner from 'vue-simple-spinner';

Vue.component('app-page', AppPage);
Vue.component('app-accordion', AppAccordion);
Vue.component('app-action-button', AppActionButton);
Vue.component('app-banner', AppBanner);
Vue.component('app-circle', AppCircle);
Vue.component('app-checkmark', AppCheckmark);
Vue.component('app-text-input', AppTextInput);
Vue.component('app-select-input', AppSelectInput);
Vue.component('app-spinner', Spinner);
Vue.component('app-checkbox-input', AppCheckboxInput);
Vue.component('app-radio-input', AppRadioInput);
Vue.component('app-image-placeholder', AppImagePlaceholder);
Vue.component('app-loading-overlay', AppLoadingOverlay);
Vue.component('app-credit-amount-container', AppCreditAmountContainer);
Vue.component('app-badge', AppBadge);
Vue.component('app-button', AppButton);
Vue.component('vue-modal', VueModal);
Vue.component('app-lookup-button', AppLookupButton);
export default new Vue({
    store,
    router,
    i18n,
    el: '#app',
  	render: (h) => h(App),
});
